import { LoaderFunction } from "react-router-dom";
import {
  getSyllabi,
  type SyllabusApiItem,
} from "../../../common/api/decimal/methods/syllabi.ts";

export interface AssignedMaterial {
  title: string;
  author: string;
}

export interface CourseDetails {
  id: string;
  courseTitle: string;
  courseCode: string;
  institution: string;
  year: number;
  description: string;
  learningObjectives: string[];
  assignedMaterials: AssignedMaterial[];
  topicOutline?: string;
}

function syllabusToDialogCourse(syllabus: SyllabusApiItem): CourseDetails {
  return {
    id: syllabus.id,
    courseTitle: syllabus.title,
    courseCode: syllabus.code,
    institution: syllabus.institution.institution,
    year: syllabus.year,
    description: syllabus.description,
    learningObjectives: syllabus.learningObjectives,
    assignedMaterials: syllabus.works.map((work) => ({
      title: work.title,
      author: work.authors.map((a) => a.author).join(", "),
    })),
    topicOutline: syllabus.topicOutline ?? undefined,
  };
}

export interface SyllabiLoaderData {
  syllabi: CourseDetails[];
  totalPages: number;
}

export const syllabiLoader: LoaderFunction = async ({ params, request }) => {
  const vbid = params.vbid ?? "";
  const url = new URL(request.url);
  const page = Number(url.searchParams.get("page")) || 1;
  const response = await getSyllabi(vbid, page);

  const meta = response.meta;
  const totalPages =
    meta &&
    Number.isFinite(meta.total) &&
    Number.isFinite(meta.perPage) &&
    meta.perPage > 0
      ? Math.ceil(meta.total / meta.perPage)
      : 1;

  const data: SyllabiLoaderData = {
    syllabi: (response.data ?? []).map(syllabusToDialogCourse),
    totalPages,
  };
  return data;
};
